import * as Yup from "yup";

// Define validation schema
const profileSchema = Yup.object().shape({
  firstName: Yup.string()
    .max(50, "First name must be less than 50 characters")
    .required("First name is required"),
  lastName: Yup.string()
    .max(50, "Last name must be less than 50 characters")
    .required("Last name is required"),
});

export default profileSchema;